import { render, staticRenderFns } from "./Skus.vue?vue&type=template&id=fc5ad95a&scoped=true&"
import script from "./Skus.vue?vue&type=script&lang=js&"
export * from "./Skus.vue?vue&type=script&lang=js&"
import style0 from "./Skus.vue?vue&type=style&index=0&id=fc5ad95a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5ad95a",
  null
  
)

export default component.exports